import { combineReducers } from 'redux';
import { createReducer } from 'typesafe-actions';

import type { Filter } from 'favoriteList/constants/filters';
import type { PlanListWithProviderId } from 'Plan-Types';
import type { ProviderWithArrayIndex } from 'Provider-Types';
import type { PlanResponse, ProviderResponse } from 'ProviderPlan-Types';
import {
  fetchFilterAsync,
  fetchMorePlansListAsync,
  fetchMoreProvidersListAsync,
  fetchPlansListAsync,
  fetchProvidersListAsync,
  setCurrentPlanDataCount,
  setCurrentPlanListStatus,
  setCurrentProviderDataCount,
  setCurrentProviderListStatus,
  setDraftPlan,
  setDraftProvider,
  setIsFavoriteHandlerSuccess,
} from './actions';

export const providerDataCount = createReducer(0 as number).handleAction(
  setCurrentProviderDataCount,
  (_state, action) => action.payload,
);

export const planDataCount = createReducer(0 as number).handleAction(
  setCurrentPlanDataCount,
  (_state, action) => action.payload,
);

export const draftProvider = createReducer({} as ProviderWithArrayIndex).handleAction(
  setDraftProvider,
  (_state, action) => action.payload,
);

export const draftPlan = createReducer({} as PlanListWithProviderId).handleAction(
  setDraftPlan,
  (_state, action) => action.payload,
);

export const isFavoriteHandlerSuccess = createReducer(false as boolean).handleAction(
  setIsFavoriteHandlerSuccess,
  (_state, action) => action.payload,
);

export const isProviderFetching = createReducer(false as boolean)
  .handleAction([fetchProvidersListAsync.request], () => true)
  .handleAction([fetchProvidersListAsync.success, fetchProvidersListAsync.failure], () => false);

export const isPlanFetching = createReducer(false as boolean)
  .handleAction([fetchPlansListAsync.request], () => true)
  .handleAction([fetchPlansListAsync.success, fetchPlansListAsync.failure], () => false);

export const isProviderFetchingMore = createReducer(false as boolean)
  .handleAction([fetchMoreProvidersListAsync.request], () => true)
  .handleAction(
    [fetchMoreProvidersListAsync.success, fetchMoreProvidersListAsync.failure],
    () => false,
  );

export const isPlanFetchingMore = createReducer(false as boolean)
  .handleAction([fetchMorePlansListAsync.request], () => true)
  .handleAction([fetchMorePlansListAsync.success, fetchMorePlansListAsync.failure], () => false);

export const providerList = createReducer({} as ProviderResponse)
  .handleAction(fetchProvidersListAsync.success, (_state, action) => action.payload)
  .handleAction(fetchMoreProvidersListAsync.success, (state, action) => {
    return {
      ...action.payload,
      body: {
        ...action.payload.body,
        providers: state.body.providers.concat(action.payload.body.providers),
      },
    };
  })
  .handleAction(setCurrentProviderListStatus, (_state, action) => action.payload);

export const planList = createReducer({} as PlanResponse)
  .handleAction(fetchPlansListAsync.success, (_state, action) => action.payload)
  .handleAction(fetchMorePlansListAsync.success, (state, action) => {
    return {
      ...action.payload,
      body: {
        ...action.payload.body,
        providerPlanList: state.body.providerPlanList.concat(action.payload.body.providerPlanList),
      },
    };
  })
  .handleAction(setCurrentPlanListStatus, (_state, action) => action.payload);

export const filter = createReducer([] as Filter[]).handleAction(
  fetchFilterAsync.success,
  (_state, action) => action.payload,
);

const providerPlanListReducer = combineReducers({
  isProviderFetching,
  isPlanFetching,
  isProviderFetchingMore,
  isPlanFetchingMore,
  providerList,
  planList,
  draftPlan,
  draftProvider,
  isFavoriteHandlerSuccess,
  providerDataCount,
  planDataCount,
  filter,
});

export default providerPlanListReducer;
export type ProviderPlanListState = ReturnType<typeof providerPlanListReducer>;
